import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

interface HorizontalStepperProps {
  activeStep: number;
  steps: string[];
  onStepChange?: (stepIndex: number) => void;
}

export const StepsVisibleForm: React.FC<HorizontalStepperProps> = ({
  activeStep,
  steps,
  onStepChange,
}) => {
  const current = Math.max(0, (activeStep ?? 1) - 1);

  return (
    <Box
      sx={{
        overflowX: "auto",
        whiteSpace: "nowrap",
        width: "100%",
        pb: 1,
        "&::-webkit-scrollbar": {
          height: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#c1c1c1",
          borderRadius: "3px",
        },
      }}
    >
      <Stack direction="row" spacing={4} justifyContent="center">
        {
          steps.map((step, index) => {
            const isActive = index === current;

            return (
              <Box
                key={index}
                display="flex"
                flexDirection="column"
                alignItems="center"
                sx={{ minWidth: "max-content" }}
                onClick={() => onStepChange?.(index + 1)}
              >
                <Typography
                  sx={{
                    fontWeight: isActive ? 600 : 400,
                    fontSize: '14px',
                    color: isActive ? '#1976d2' : '#6b6b6b',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    userSelect: "none",
                  }}
                >{step}</Typography>

                <Box
                  sx={{
                    mt: '2px',
                    height: '2px',
                    width: '100%',
                    backgroundColor: isActive ? '#1976d2' : 'transparent',
                  }}
                />
              </Box>
            )
          })
        }
      </Stack>
    </Box>
  )
}
